
import { mapState, mapMutations } from "vuex";
import { Cars } from "@/graphql/cars";

export default {
  nuxtI18n: {
    paths: {
      "en-ca": "/automotives",
      "fr-ca": "/automobiles",
    },
  },
  async asyncData({ app, i18n }) {
    const client = app.apolloProvider.defaultClient;
    const locale = i18n.locale.slice(0, 3) + i18n.locale.slice(3).toUpperCase();
    const automotiveResponse = await client.query({
      query: Cars,
      variables: { locale: locale },
    });
    const automobile = automotiveResponse.data.automobile.data.attributes;
    return { automobile };
  },
  data() {
    return {
      automobile: {},
      show: false,
      anchorSelected: "",
    };
  },
  head() {
    return {
      title: this.automobile.SEO.MetaTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.automobile.SEO.MetaDescription,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.automobile.SEO.MetaDescription,
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => this.setPageAnimation("animBanner"), 500);
  },
  computed: {
    ...mapState(["pageScroll"]),
  },
  methods: {
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
    }),
  },
  watch: {
    pageScroll: function () {
      //Ajouter - le height du Header fix apres le bottom
      let haveShow = false;
      if (
        this.$refs.animated?.getBoundingClientRect().bottom -
          window.innerHeight +
          90 <=
        0
      ) {
        this.show = true;
        haveShow = true;
      }
    },
  },
};
